import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useDeleteBillingNote } from '@/billing/hooks/useDeleteBillingNote';
import { Button } from '@/common/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/common/components/ui/dialog';

type DeleteBillingNoteDialogProps = {
  billingUuid: string;
  noteUuid: string;
  onClose: () => void;
};

export const DeleteBillingNoteDialog = ({
  billingUuid,
  noteUuid,
  onClose,
}: DeleteBillingNoteDialogProps) => {
  const { t } = useTranslation();
  const { deleteNote, isPending } = useDeleteBillingNote();

  const onConfirm = async () => {
    try {
      await deleteNote({ billingUuid, noteUuid });
      onClose();
      toast.success(t('billing.notesHistory.noteDeleted'));
    } catch {
      toast.error(t('billing.notesHistory.noteDeleteError'));
    }
  };

  return (
    <Dialog open onOpenChange={() => !isPending && onClose()}>
      <DialogContent className="w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('billing.notesHistory.deleteTitle')}</DialogTitle>
          <DialogDescription>
            {t('billing.notesHistory.deleteDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            {t('actions.cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
          >
            {t('actions.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
